import { render, staticRenderFns } from "./rate-deal.vue?vue&type=template&id=b3dfb5ec&scoped=true&"
import script from "./rate-deal.vue?vue&type=script&lang=js&"
export * from "./rate-deal.vue?vue&type=script&lang=js&"
import style0 from "./rate-deal.vue?vue&type=style&index=0&id=b3dfb5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dfb5ec",
  null
  
)

export default component.exports